export default __webpack_public_path__ + "static/hp-7fc28032a545f014658baaa72f648e2c.jpg";